import React, { useEffect, useState } from 'react';
import { defer } from '/imports/utils';
import { InputStyled, InputProps } from '/imports/ui/Input';
import { Icon } from '/imports/ui/Icon';

const allowedChars = '01234567890-x(),';

const marshalValue = (value: string) => {
  let marshalled = '';
  for (let i = 0; i < value.length; i++) {
    const c = value.charAt(i);
    if (allowedChars.includes(c)) marshalled += c;
  }
  return marshalled;
};

export const PhoneInput = (props: InputProps) => {
  const value = props.value && `${props.value}` || '';
  const hasStartIcon = props.icon && props.iconPlacement !== 'end';
  const [change, setChange] = useState<{ event?: React.ChangeEvent<HTMLInputElement>, value: string }>();
  useEffect(() => {
    if (!change) return;
    const { value, event } = change;
    const _value = marshalValue(value);
    props.onChange?.(_value, event);
  }, [change]);
  const clearInput = () => {
    setChange({ value: '' });
    props.onClear?.();
  };
  return (
    <InputStyled id={props.id} className={`input ${props.className || ''}${props.hasError ? ' error' : ''}`}>
      {hasStartIcon && <Icon className="icon-start" icon={props.icon as any} />}
      <input
        id={props.inputId}
        className={hasStartIcon ? 'has-start-icon' : ''}
        type="tel"
        placeholder={props.placeholder || ''}
        disabled={props.disabled}
        autoFocus={props.autoFocus}
        value={change?.value || value || ''}
        onChange={(e: any) => setChange({ event: e, value: e.target.value })}
        onClick={(e) => props.onClick?.(e)}
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        onKeyUp={(e) => {
          props.onKeyPress?.(e);
          if (e.key === 'Enter') {
            defer(() => props.onEnter?.(props.value, e));
          }
        }}
        autoComplete={props.autoComplete}
      />
      {
        props.value?.length &&
        !props.disabled &&
        !(props.type === 'color') &&
        <Icon className="clear" icon="cancel" onClick={() => clearInput()} /> || null
      }
    </InputStyled>
  );
};